import Header from './components/Header';
import Hero from './components/Hero';
import TopicsSection from './components/TopicsSection';
import CommentsSection from './components/CommentsSection';
import CardsSection from './components/CardsSection';
import RankingSection from './components/RankingSection';
import FaqSection from './components/FaqSection';
import AboutSection from './components/AboutSection';
import UpdatesSection from './components/UpdatesSection';
import FeaturesSection from './components/FeaturesSection';
import AppSection from './components/AppSection';
import CarouselSection from './components/CarouselSection';
import ContactSection from './components/ContactSection';
import IndexSection from './components/IndexSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <TopicsSection />
        <CommentsSection />
        <CardsSection />
        <RankingSection />
        <FaqSection />
        <AboutSection />
        <UpdatesSection />
        <FeaturesSection />
        <AppSection />
        <CarouselSection />
        <ContactSection />
        <IndexSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}